var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "pin_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.784 41.917 4.3 27.433l25.058-7.914L39.82 4.087 59.914 24.18 44.48 34.643l-7.913 25.058-14.484-14.484L7.3 60 4 56.7z",
    clipRule: "evenodd"
  })));
};
export { SvgPin as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE4Ljc4MzcgNDEuOTE2OUw0LjI5OTYgMjcuNDMyOEwyOS4zNTc1IDE5LjUxOTRMMzkuODIwNCA0LjA4NjkxTDU5LjkxMzcgMjQuMTgwM0w0NC40ODEyIDM0LjY0M0wzNi41Njc3IDU5LjcwMDlMMjIuMDgzNSA0NS4yMTY3TDcuMjk5ODIgNjAuMDAwM0w0IDU2LjcwMDVMMTguNzgzNyA0MS45MTY5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";